import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation changeStripeDataMutation($input: ChangeStripeDataInput!) {
		changeStripeData(input: $input) {
			errors
			company {
				subscription {
					email
					cardLast4
					cardType
					cardholderName
					expirationDate
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const changes = [];
	if (input.invoiceEmail) {
		changes.push('Email');
	}
	if (input.changeToAnnual) {
		changes.push('Upgrade To Annual');
	}
	tracking.trackEvent('Stripe Data Changed', {_Changed: changes});

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation(environment, {
		mutation,
		variables,
		configs: [],
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
